export default {
  install: function install(Vue, options) {
    var driverCustomBehavior = {};

    driverCustomBehavior.clickToNext = function (element, driver) {
      element.addEventListener("click", function () {
        return driver.moveNext();
      });
    };

    driverCustomBehavior.focusToNext = function (element, driver) {
      element.addEventListener("focus", function () {
        return driver.moveNext();
      });
    };

    Vue.prototype.driverCustomBehavior = driverCustomBehavior;
  }
};